import Vue from 'vue'
import Vuex from 'vuex'
// 应用vuex插件
Vue.use(Vuex)

// 创建并暴露store
export default new Vuex.Store({
	// 数据,相当于data
	state: {
		language: 'zh',
		theme: 'red',
		menuActiveIndex: '0',
		periodName: '',
		periodNameEng: '',
		jsonData: {},
		envConfig: {},
		isLongChart: false,
	},
	//准备getters——用于将state中的数据进行加工
	getters: {},
	//准备mutations——用于操作数据（state）
	mutations: {
		setLanguage(state, value) {
			state.language = value
		},
		setTheme(state, value) {
			state.theme = value
		},
		setMenuActiveIndex(state, value) {
			state.menuActiveIndex = value
		},
		setJsonData(state, value) {
			state.jsonData = value
		},
		setPeriodName(state, value) {
			state.periodName = value
		},
		setPeriodNameEng(state, value) {
			state.periodNameEng = value
		},
		setEnvConfig(state, value) {
			state.envConfig = value
		},
		setIsLongChart(state, value) {
			state.isLongChart = value
		},
	},
	//准备actions——用于响应组件中的动作
	actions: {},
	modules: {},
})
